import Vue from 'vue';

// When the request succeeds
const success = (response, context) => {
  if (response.superCheckin) {
    context.accountLockTypes = [
      ...context.accountLockTypes,
      {type: 'SuperCheckin'}
    ];
  }
  if (response.theKeys) {
    context.accountLockTypes = [
      ...context.accountLockTypes,
      {type: 'TheKeys'}
    ];
  }

  if (response.igloohome) {
    context.accountLockTypes = [
      ...context.accountLockTypes,
      {type: 'Igloohome'}
    ];
  }

  if (response.nuki) {
    context.accountLockTypes = [
      ...context.accountLockTypes,
      {type: 'Nuki'}
    ]
  }
};

// When the request fails
const failed = (error, context) => {

};

export default (context, params) => {
  return Vue.$http.post('/rentals/get-account-lock-types', params).then((response) => {
    if (response && response.status === 200) {
      success(response.data, context);
    }
  })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/account/getAccountLockTypes.js